import { useRef, useState } from 'react';

import { ListCheckbox, Menu, MultiSelect } from '@scaleaq/scaleui';

interface CompactMultiSelectProps {
  onChange: (ids: string[]) => void;
  value: string[];
  options: string[];
  label?: string;
}

export const CompactMultiSelect = ({
  onChange,
  value,
  options,
  label,
}: CompactMultiSelectProps) => {
  const multiSelectRef = useRef<HTMLDivElement>(null);
  const [multiselectOpen, setMultiselectOpen] = useState(false);

  const selectedIds = value ?? [];
  const displayValue = selectedIds.join(', ');

  const handleSelect = (ids: string[]) => {
    onChange(ids);
  };

  return (
    <Menu
      anchorEl={multiSelectRef as React.RefObject<HTMLDivElement>}
      open={multiselectOpen}
      onClose={() => setMultiselectOpen(false)}
      menuElement={
        <ListCheckbox
          toggleAll
          ids={selectedIds}
          onChange={handleSelect}
          items={options?.map(o => ({ label: o, id: o }))}
        />
      }
    >
      <MultiSelect
        open={multiselectOpen}
        setOpen={setMultiselectOpen}
        label={label}
        value={displayValue}
        width='100%'
      />
    </Menu>
  );
};
